import { observer } from 'mobx-react-lite';
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Box from 'ui-box';
import { Button, ITableProps, Spinner, Table } from '../../npaper';
import {
  IContactGroup,
  IContactGroupSnapshotOut,
} from '../../stores/contacts/ContactGroupStore';
import { useStores } from '../../stores/Root';
import {
  IPaginationFilter,
  IQueryCache,
} from '../../stores/utils/modelWithCRUD';

export interface IContactGroupsTableProps extends ITableProps {
  filter?: IPaginationFilter<IContactGroupSnapshotOut>;
  onRemove?: (group: IContactGroup) => any;
  hideHeader?: boolean;
}

export const ContactGroupsTable: React.FC<IContactGroupsTableProps> = observer(
  ({ filter, hideHeader, onRemove, ...props }) => {
    const { contactGroupStore } = useStores();
    const [needsMore, setNeedsMore] = useState(true);

    const [res, setRes] = useState<IQueryCache<IContactGroup>>();

    useEffect(() => {
      let isSub = true;
      contactGroupStore.fetchMore(filter).then((res) => {
        if (isSub) {
          setRes(res);
          setNeedsMore(false);
        }
      });
      return () => {
        isSub = false;
      };
    }, [contactGroupStore, filter, needsMore]);

    return !res || !res.items || res.isLoading ? (
      <Spinner size={16} />
    ) : res.items.length === 0 ? (
      <Box is="p">
        <FormattedMessage defaultMessage="No groups assigned" />
      </Box>
    ) : (
      <>
        <Table {...props} onScrollNearBottom={() => setNeedsMore(true)}>
          {!hideHeader && (
            <thead>
              <tr>
                <th>
                  <FormattedMessage defaultMessage="Group name" />
                </th>
                <th style={{ width: 40 }}></th>
              </tr>
            </thead>
          )}
          <tbody>
            {res.items.map((group) => (
              <tr key={group.id}>
                <td>{group.name}</td>
                <td style={{ width: 40 }}>
                  <Button
                    iconLeft="trash"
                    minimal
                    onClick={() => onRemove && onRemove(group)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );
  }
);
